export class UserSearchVO{
    firstName: string;
    emailId: string;
    lastName: string;
    profileName: string;
    roleName: string;
    applicationId:number;
}